import { MenuItemIcon } from '@/components/MenuItem/MenuItemIcon';
import Middle from '@/images/position/align/Middle.svg';
import { useAdvancedEditorContext } from '@/pages/AdvancedEditor/context/useAdvancedEditorContext';
import { alignElementsMiddle } from '../../../../actions/align/Middle';

export const MiddleMenuItem = () => {
    const { store } = useAdvancedEditorContext();
    const selectedElements = store.selectedElements;

    const handleClick = () => {
        alignElementsMiddle(store, selectedElements);
    };

    return <MenuItemIcon onClick={handleClick} src={Middle} text="Middle" />;
};
